module.exports = __webpack_public_path__ + "static/media/IR.9d2282a4.svg";